import { Icon, type IconProps } from "./icon";

/** Emails: the envelope, its flap closed. */
export function EmailsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="2.75" y="4.75" width="14.5" height="10.5" rx="1.5" />
      <path d="M3.25 5.5 10 10.5l6.75-5" />
    </Icon>
  );
}
